module.exports = __webpack_public_path__ + "static/media/2.fd0495b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/world-allergy-day-2017/2.png
// module id = 660
// module chunks = 0